import { localStorage } from 'dibs-browser-storage';
import {
    DESIGN_MANAGER_PRO,
    DESIGN_MANAGER_STANDARD,
} from 'dibs-trade-design-manager/exports/tradeDesignManagerAuthHelpers';

import { hasSubmittedDesignManagerUpgradeRequest } from '../../global/tradeOnboarding/tradeDesignManagerOnboardingRules';
import { DESIGN_MANAGER_UPGRADED } from '../PdpRespIconBubbles/PdpRespIconBubbleDesignManager';

import { fetchQuery, graphql } from 'react-relay';
import get from 'lodash.get';

const query = graphql`
    query fetchTradeDesignManagerOnboardingQuery($userId: String!) {
        viewer {
            user(userId: $userId) {
                tradeFirmDesignManagerProfile {
                    accountType
                }
            }
        }
    }
`;

const PDP_COACHMARK_DM_MAX_VIEWS = 10;

export const PDP_COACHMARK_DM_PRO_VIEWS_LOCAL_STORAGE_KEY =
    'pdp_trade_design_manager_pro_onboarding_coachmark_views';
export const PDP_COACHMARK_DM_PRO_TOOLTIP_DISMISSED =
    'pdp_trade_design_manager_pro_onboarding_tooltip_dimissed';

export const PDP_COACHMARK_DM_STANDARD_VIEWS_LOCAL_STORAGE_KEY =
    'pdp_trade_design_manager_standard_onboarding_coachmark_views';
export const PDP_COACHMARK_DM_STANDARD_TOOLTIP_DISMISSED =
    'pdp_trade_design_manager_standard_onboarding_tooltip_dimissed';

export const getPdpCoachmarkMaxViewsExceeded = coachmarkView =>
    localStorage.getItem(coachmarkView) > PDP_COACHMARK_DM_MAX_VIEWS;

export const getWasPdpTooltipDismissed = tooltip => localStorage.getItem(tooltip);

export const logCoachmarkViewForItem = coachmarkView => {
    const views = localStorage.getItem(coachmarkView) || 0;
    localStorage.setItem(coachmarkView, views + 1);
};

export const logPdpTooltipDismissal = tooltip => {
    localStorage.setItem(tooltip, true);
};

const isProOnboardingCoachmarkExpired =
    getWasPdpTooltipDismissed(PDP_COACHMARK_DM_PRO_TOOLTIP_DISMISSED) ||
    getPdpCoachmarkMaxViewsExceeded(PDP_COACHMARK_DM_PRO_VIEWS_LOCAL_STORAGE_KEY);

const isStandardOnboardingCoachmarkExpired =
    getWasPdpTooltipDismissed(PDP_COACHMARK_DM_PRO_TOOLTIP_DISMISSED) ||
    getPdpCoachmarkMaxViewsExceeded(PDP_COACHMARK_DM_PRO_VIEWS_LOCAL_STORAGE_KEY);

export const isOnboardingDesignManagerCoachmarkExpired = () => {
    if (hasSubmittedDesignManagerUpgradeRequest() === DESIGN_MANAGER_UPGRADED) {
        return isProOnboardingCoachmarkExpired;
    }
    return isProOnboardingCoachmarkExpired || isStandardOnboardingCoachmarkExpired;
};

export const canSkipDesignManagerOnboardingCoachmark = ({ relayEnvironment, userId }) => {
    return fetchQuery(relayEnvironment, query, {
        userId,
    }).then(res => {
        const accountType = get(res, 'viewer.user.tradeFirmDesignManagerProfile.accountType');
        return accountType !== DESIGN_MANAGER_PRO && accountType !== DESIGN_MANAGER_STANDARD;
    });
};
